if (!customElements.get('hornet-reasons')) {
  customElements.define('hornet-reasons', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const packs = this.querySelector('[data-hs-packs]');
      const form = this.querySelector('.hs-form');
      const button = this.querySelector('[data-hs-submit]');
      if (packs && form && button) {
        const pairRadio = packs.querySelector('[value="2"]');
        pairRadio.disabled = false;
        const updatePack = () => {
          if (button.getAttribute('aria-busy') === 'true') return;
          const pair = pairRadio.checked;
          const ready = !pair || packs.dataset.pairReady === 'true';
          const available = packs.dataset[pair ? 'pairAvailable' : 'singleAvailable'] === 'true';
          const price = this.querySelector(pair ? '[data-hs-pair-price]' : '[data-hs-single-price]');
          this.querySelectorAll('[data-hs-sticky-price]').forEach(node => { node.textContent = price.textContent; });
          button.disabled = !available || !ready;
          button.textContent = !available ? button.dataset.soldOutLabel : !ready ? button.dataset.pendingLabel : pair ? button.dataset.pairLabel : button.dataset.availableLabel;
          this.querySelector('[data-hs-pack-note]').hidden = ready;
          this.querySelector('[data-hs-pair-stock-note]').hidden = !pair || available || packs.dataset.singleAvailable !== 'true';
          this.querySelector('[data-hs-stock-note]').hidden = packs.dataset.singleAvailable === 'true';
        };
        packs.addEventListener('change', updatePack, { signal });
        this.querySelector('[data-hs-variant]')?.addEventListener('change', event => {
          const option = event.target.selectedOptions[0];
          packs.dataset.singleAvailable = option.dataset.available;
          packs.dataset.pairAvailable = option.dataset.pairAvailable;
          for (const [selector, key] of [['[data-hs-single-price]', 'price'], ['[data-hs-pair-price]', 'pairPrice'], ['[data-hs-pair-unit]', 'pairUnit'], ['[data-hs-pair-regular]', 'pairRegular']]) {
            this.querySelector(selector).textContent = option.dataset[key];
          }
          updatePack();
        }, { signal });
        form.addEventListener('submit', event => {
          updatePack();
          if (button.disabled) event.preventDefault();
        }, { signal });
        updatePack();
      }
      const sticky = this.querySelector('[data-hs-sticky]');
      const hero = this.querySelector('.hs-hero');
      const offer = this.querySelector('.hs-offer');
      if (sticky && hero && offer && 'IntersectionObserver' in window) {
        let pastHero = false;
        let nearOffer = false;
        const update = () => { sticky.hidden = !pastHero || nearOffer; };
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === offer) nearOffer = entry.isIntersecting || entry.boundingClientRect.top < 0;
          });
          update();
        });
        this.observer.observe(hero);
        this.observer.observe(offer);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
